import { createContext, useRef } from "react";
import {
  createProjectStoreFormStore,
  ProjectStoreFormStoreApi,
} from "./projectStoreFormStore";

export const ProjectStoreFormStoreContext =
  createContext<ProjectStoreFormStoreApi | null>(null);

export const ProjectStoreFormStoreProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const storeRef = useRef<ProjectStoreFormStoreApi | null>(null);
  if (storeRef.current === null) {
    storeRef.current = createProjectStoreFormStore();
  }
  return (
    <ProjectStoreFormStoreContext.Provider value={storeRef.current}>
      {children}
    </ProjectStoreFormStoreContext.Provider>
  );
};
